module.exports = __webpack_public_path__ + "static/media/anders-jilden.000e7dff.jpg";